export default __webpack_public_path__ + "static/hw_button-560881aac769d22585e39c476fba211f.jpg";